import { render, staticRenderFns } from "./krpano.vue?vue&type=template&id=2f2beee8&scoped=true&"
import script from "./krpano.vue?vue&type=script&lang=js&"
export * from "./krpano.vue?vue&type=script&lang=js&"
import style0 from "./krpano.vue?vue&type=style&index=0&id=2f2beee8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2beee8",
  null
  
)

export default component.exports